import { fetchWrapper } from '../helpers';

export const openstreetmapService = {
  getLocations,
  setMapFeatures
};

const baseUrl = `https://nominatim.openstreetmap.org`;

/*
function getLocations(q, format = "geojson") {
  const URL = `${baseUrl}/search?q=${encodeURIComponent(q)}&format=${format}`;
  return fetchWrapper.get(URL);
}
*/

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

async function setMapFeatures(locations = []) {
  await asyncForEach(locations, async (loc) => {
    const featureCollection = await getLocations(loc);
    loc.features = featureCollection.features.slice(0, 1);
  });
}

async function getLocations(location, format = "geojson") {
  const { location_street, location_city, location_country } = location;
  //
  const URL = `${baseUrl}/search?street=${encodeURIComponent(location_street)}&city=${encodeURIComponent(location_city)}&county=${location_country.value}&format=${format}&limit=2`;
  return fetchWrapper.get(URL);
}